export default __webpack_public_path__ + "static/media/add-fee-enabled.2b952e07.svg";